import React from 'react'
import styled from 'styled-components'
import Checkbox from 'components/atoms/Checkbox'

const LABEL = 'Onward sharing allowed'

const helperFor = viewerIsUploader =>
  `When ticked, your organisation’s Super Admins can also approve requests to open this document. When unticked, only ${
    viewerIsUploader === true ? 'you decide' : 'the person who uploaded it decides'
  }.`

const OnwardSharingCheckbox = ({
  checked,
  onChange,
  disabled = false,
  lockedByFolder = null,
  appliesNote = null,
  viewerIsUploader = null,
  label = LABEL,
  helper = null
}) => {
  if (appliesNote) {
    return (
      <Wrapper>
        <Note>{appliesNote}</Note>
      </Wrapper>
    )
  }

  const locked = Boolean(lockedByFolder)
  const isDisabled = disabled || locked

  return (
    <Wrapper>
      <Checkbox
        size='large'
        name='onward_sharing_allowed'
        label={label}
        isChecked={locked ? false : Boolean(checked)}
        disabled={isDisabled}
        onChange={(_, value) => !isDisabled && onChange && onChange(Boolean(value))}
      />
      <Help>{helper || helperFor(viewerIsUploader)}</Help>
      {locked && (
        <Note>
          Turned off by the folder {lockedByFolder}. Change it in that folder’s access settings.
        </Note>
      )}
    </Wrapper>
  )
}

export default OnwardSharingCheckbox

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Help = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #475467;
`

const Note = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #344054;
`
